import { render, staticRenderFns } from "./Sales12MonthsSalesNumberDisplayer.vue?vue&type=template&id=eedb12a8"
import script from "./Sales12MonthsSalesNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./Sales12MonthsSalesNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports